import { Component, Inject } from '@angular/core';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IKonstantesQueryShapes, KonstantesQueryFilterConfig } from 'fa-kt.types';
import { KonstantesService } from '../service';

@Component({
  selector: 'fa-kt-konstantes-filter',
  templateUrl: './konstantes-filter.component.html',
  styleUrls: ['./konstantes-filter.component.css'],
})
export class KonstantesFilterComponent {
  readonly subscriptions: Subscription[] = [];

  KonstantesFilterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public konstantes: KonstantesService,
  ) {
    this.KonstantesFilterConfig = KonstantesQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push(
      this.konstantes.shapes$.subscribe((shapes: IKonstantesQueryShapes | undefined) => {
        if (!shapes) {
          return;
        }
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.KonstantesFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.KonstantesFilterConfig[index].selections = shapes;
  }
}
